// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
// import cookies from 'vue-cookies'
import VueCookies from "vue-cookies";
Vue.use(VueCookies);


//引用组织架构框架组件
import Vue2OrgTree from 'vue2-org-tree'
import 'vue2-org-tree/dist/style.css'
Vue.use(Vue2OrgTree)


// ui框架
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.config.productionTip = false;
// element 组件全局配置
Vue.use(ElementUI, {
  size: "small",
  zIndex: 3000
});
// cookies
// Vue.prototype.$cookies = cookies;

import echarts from "echarts";
Vue.prototype.$echarts = echarts;



// 在注册之前执行路由拦截
router.beforeEach((to, from, next) => {
  // VueCookies.set('vertical_nav_index','1-1')
  // 验证参数
  if (to.meta.routerAuth) {
    if (to.path == "/author") {
      next();
      return;
    }
    let token = VueCookies.get("token") ? true : false;
    if (token) {
      next();
    } else {
      // 跳到登录
      next("/");
    }
  } else {
    if (to.path == "/author") {
      next();
      return;
    }

    if (to.name) {
      next();
    } else {
      // 跳到登录
      next("/");
    }
  }
});

/* eslint-disable no-new */
window.vm = new Vue({
  el: "#app",
  router,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js